import PropTypes from "prop-types";
import { itemSurveyPropType } from "./item-survey-prop-type";

export const happinessSurveyPropType = PropTypes.shape({
  completedSurveys: PropTypes.arrayOf(itemSurveyPropType),
  itemSurveys: PropTypes.arrayOf(itemSurveyPropType),
});
